/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-12-31 15:16:48                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2024-12-31 16:57:27                               *
 *****************************************************************************/

/* SUMMARY
  * CompInfoInputText: Text compinfo component
*/

import { openNativePicker } from "../../date/openNativePicker";

/**
* CompInfoInputText: Text compinfo component
* @param value - current value
* @param onChange - on value change event
* @param className - additionnal classname
*/
export default function CompInfoInputText({
  value,
  onChange,
  className = "",
  type = "text"
}: {
  value: string,
  onChange: (data: string) => void,
  className?: string,
  type?: "text" | "email" | "tel" | "time"
}) {
  return (
    <>
      <input  type={type}
              placeholder="ex: ..."
              value={value}
              className={className}
              onClick={type === "time" ? openNativePicker : undefined}
              onChange={(el) => onChange(el.target.value)}/>
    </>
  );
}
/***/
